export function randomInt(max: number) {
    return Math.floor(Math.random() * max);
}
